<template>
	<div :class="$style['smart-image']">
		<img
			v-if="httpsSrc"
			v-show="isLoaded"
			ref="image"
			:style="height ? `height:${height}` : ''"
			:class="[$style['smart-image__tag'], contain && $style['smart-image__tag--contain']]"
			:alt="alt"
		/>

		<div
			v-show="!isLoaded"
			:style="height ? `height:${height}` : ''"
			:class="$style['smart-image__skeleton']"
		/>
	</div>
</template>

<script>

export default {
	name: 'BaseImage',
	props: {
		contain: {
			type: Boolean,
			default: false
		},
		src: {
			type: String,
			required: true
		},
		alt: {
			type: String,
			required: true
		},
		height: {
			type: String,
			default: null
		}
	},
	data () {
		return {
			isLoading: true,
			isLoaded: false,
			image: null
		}
	},

	computed: {
		httpsSrc () {
			return this.src
			// return this.src.replace('http:', 'https:')
		}
	},

	mounted () {
		this.image = this.$refs.image
		if (this.image) {
			this.image.addEventListener('load', this.onImageLoad)
			this.image.addEventListener('error', this.onImageError)
			this.image.setAttribute('src', this.httpsSrc)
		}
	},

	beforeDestroy () {
		if (this.image) {
			this.image.removeEventListener('load', this.onImageLoad)
			this.image.removeEventListener('error', this.onImageError)
		}

	},

	methods: {
		onImageLoad () {
			this.isLoading = false
			this.isLoaded = true
		},

		onImageError () {
			this.isLoading = false
			this.isLoaded = false
		}
	}
}
</script>

<style lang="scss" module>
.smart-image {
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
		// border-radius: 4px;

		&__tag {
			width: 100%;
			height: 100%;
			object-fit: cover;
			vertical-align: top;
			user-select: none;
			pointer-events: none;

			&--contain {
				object-fit: contain;
			}
		}

		&__skeleton {
			display: flex;
			width: 100%;
			height: 100%;
			background-color: getColor(chip-light);
			will-change: opacity;
			animation: pulse 1.2s ease-in-out infinite;

			@keyframes pulse {
				0%, 100% { opacity: 1; }
				50% { opacity: 0.5; }
			}
		}
	}
</style>
